import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import { BuyerState } from '../types';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "adopts_buyer_shared" */
        '../redux/BuyerModuleLoader'
      )
  )
);

const LoadableModal = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "adopts_buyer_shared" */
        './BuyerModal'
      )
  )
);

interface Props {
  deviation?: PapiDeviation;
  onRequestClose: () => void;
  initialScreen?: BuyerState['buyerCurrentScreen'];
}

const BuyerModalLoadable: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="BuyerModalLoadable">
    <Suspense
      fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}
    >
      <LoadableRedux />
      <LoadableModal {...props} />
    </Suspense>
  </ErrorBoundary>
);
BuyerModalLoadable.displayName = 'BuyerModalLoadable';

export default BuyerModalLoadable;
